import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import { accessRole } from "../../../../helpers/access_role"

  var reformatType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.retired_type_name;
      newObj["value"] = region.retired_type_uuid;
      return newObj;
    });
  };



class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                uuid:"",
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                tgl_pensiun:"",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
                tmt_pensiun: "",
                usia: "",
                usia_pensiun: "",
                sisa_masa_kerja: "",
                tusk: "",
                mpp: "",
                documents_path: ""
            },
            typeItems:[],
            typeSelected:""
        }
    }

    submitData = async () => {
          if(this.state.dataForm.document.length > 0){
            let formData = generateFormData(this.state.dataForm, 'document') 
            await this.updateBloc.fetchUpdate(formData)
        }else{
            await this.updateBloc.fetchUpdate(this.state.dataForm)
        }     
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    onChangeTypeSelected = (type) => {
        this.setState({
            typeSelected: type.value,
        });
    }   
  
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        // load to form
                        this.setState({
                            dataForm: {
                                uuid: response.retired_uuid,
                                nip: response.retired_employee_nip,
                                nama: response.retired_employee_name,
                                unit_kerja: response.retired_employee_work_unit_name,
                                jabatan: response.retired_employee_position_name,
                                tmt_jabatan: response.retired_employee_position_tmt,
                                tgl_pensiun: response.retired_employee_retired_date,
                                golongan:  response.retired_employee_level_name,
                                tgl_lahir: response.retired_employee_birth_date,
                                jenis_kelamin: response.gender_name,
                                tmt_pensiun: response.retired_employee_retired_date_tmt,
                                usia: response.employee_age,
                                usia_pensiun: response.employee_age_retired,
                                sisa_masa_kerja: response.employee_work_age,
                                tusk: response.retired_employee_tusk,
                                mpp: response.retired_employee_mpp
                            },
                            typeSelected: response.retired_employee_retired_type_uuid,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            typeItems: reformatType(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })

        const search = window.location.search
        const queryParams = new URLSearchParams(search)
        this.updateBloc.fetchDetail({ uuid: queryParams.get('uuid') })

        this.updateBloc.fetchType()
       
    }

    

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Edit Data Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />

                                    
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <AvField
                                                name="uuid"
                                                type="hidden"
                                                id="uuid"
                                                value={this.state.dataForm.uuid}
                                        />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jabatan"
                                                    id="jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Jabatan 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_jabatan"
                                                    id="tmt_jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tmt_jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Golongan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="golongan"
                                                    id="golongan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.golongan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_lahir"
                                                    id="tgl_lahir"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_lahir}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jenis_kelamin"
                                                    id="jenis_kelamin"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jenis_kelamin}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pensiun 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_pensiun"
                                                    id="tgl_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Pensiun 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_pensiun"
                                                    id="tmt_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tmt_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                       

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Usia 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="usia"
                                                    id="usia"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.usia}
                                                />
                                            </Col>
                                        </Row>

                                          <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Usia Pensiun
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="usia_pensiun"
                                                    id="usia_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.usia_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Sisa Masa Kerja 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="sisa_masa_kerja"
                                                    id="sisa_masa_kerja"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.sisa_masa_kerja}
                                                />
                                            </Col>
                                        </Row>
                                       
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <Select
                                                    value={this.state.typeItems.filter(option => 
                                                      option.value === this.state.typeSelected)}
                                                    onChange={
                                                      this.onChangeTypeSelected
                                                    }
                                                    required="required"
                                                    options={this.state.typeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Jenis"
                                                />
                                                <AvField
                                                    name="retired_employee_retired_type_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="retired_employee_retired_type_uuid"
                                                    value={this.state.typeSelected}
                                                />
                                            </Col>
                                        </Row>


                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TUSK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="tusk"
                                                    id="tusk"
                                                    placeholder="TUSK"
                                                    type="text"
                                                    errorMessage="TUSK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.tusk}
                                                />
                                            </Col>
                                        </Row>

                                        
                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            MPP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="mpp"
                                                    id="mpp"
                                                    placeholder="MPP"
                                                    type="text"
                                                    errorMessage="MPP"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.mpp}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            File SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            Dokumen SK Terupload
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.dataForm ?
                                                        <>{this.state.dataForm.documents_path !== "" ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.dataForm.documents_path}>
                                                            <i className="uil-file-download"></i> Download File
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                       
                                    
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/pensiun.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pensiun.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView